import { AuthContext } from '@repo-level/core-front';
import { ONE_SIGNAL_ID } from 'helpers/conf';
import { createContext, useContext, useEffect, useState } from 'react';
import ReactOneSignal from 'react-onesignal';

const oneSignalBuilder =
  (appId: string | undefined) => async (userId: number, email: string) => {
    try {
      if (appId == null || appId === '') {
        console.warn('OneSignal appId is not defined');
        return;
      }

      await ReactOneSignal.init({
        appId,
        allowLocalhostAsSecureOrigin: true,
      });

      ReactOneSignal.setExternalUserId(userId.toString());
      ReactOneSignal.setEmail(email);
    } catch {}
  };

const oneSignal = oneSignalBuilder(ONE_SIGNAL_ID);

export const OneSignalContext = createContext<{}>(null as any);

export const OneSignalContextProvider: React.FC = ({ children }) => {
  const { user } = useContext(AuthContext);

  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    if (user?.id != null && user.email != null) {
      oneSignal(user.id, user.email).then(() => setInitialized(true));
    }
  }, [user]);

  return (
    <OneSignalContext.Provider value={{ initialized }}>
      {children}
    </OneSignalContext.Provider>
  );
};
